import { ChangeDetectorRef, Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { RsLoaderService } from '../services/rs-loader.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'rs-loader',
  templateUrl: './rs-loader.component.html',
  styleUrls: ['./rs-loader.component.scss'],
  imports: [
    TranslateModule,
    MatProgressSpinnerModule
  ]
})
export class RsLoaderComponent implements OnInit {

  // DEPENDENCY INJECTION
  private readonly rsLoaderService= inject(RsLoaderService,);
  private readonly changeDetectorRef= inject(ChangeDetectorRef);
  private readonly destroyRef$ = inject(DestroyRef);

  @Input() public showSpinners: boolean = false;

  public showSpinner: boolean = false;

  public get currentMessage(): string {
    return this.rsLoaderService.currentMessage ?? '';
  }

  public get backgroundOpacity(): number {
    return this.rsLoaderService.backgroundOpacity;
  }

  public ngOnInit(): void {
    this.rsLoaderService
      .showSpinner
      .pipe(takeUntilDestroyed(this.destroyRef$))
      .subscribe({
        next: (doShow) => {
          const addRemove = doShow ? 'add' : 'remove';
          document.getElementsByTagName('body')[0]?.classList[addRemove]('no-scroll');
          this.showSpinner = doShow;
          this.changeDetectorRef.markForCheck();
        }
      })
  }
}
